"use client";

import { c as _c } from "react/compiler-runtime";
import { appStoreUrl, playStoreUrl } from "@/components/footer/social-links";
import { Smartphone } from "lucide-react";
import { useEffect, useState } from "react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";
export function DownloadAppCard(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const [link, setLink] = useState(null);
  const [label, setLabel] = useState("Download App");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      if (/android/i.test(userAgent)) {
        setLink(playStoreUrl);
        setLabel("Get it on Google Play");
      } else {
        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
          setLink(appStoreUrl);
          setLabel("Download on App Store");
        }
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Smartphone className="w-full h-full" strokeWidth={1.5} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = link ? label : undefined;
  const t5 = link || undefined;
  let t6;
  if ($[3] !== link) {
    t6 = !link && <div className="flex gap-3 text-xs font-medium text-primary-600 mt-1"><a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="hover:underline">App Store</a><span className="text-gray-300">|</span><a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="hover:underline">Google Play</a></div>;
    $[3] = link;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== className || $[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = <PromotionalCardBase icon={t3} title="Experience Better on App" description="Get smoother browsing, instant alerts & exclusive features" ctaText={t4} href={t5} isExternal={true} className={className}>{t6}</PromotionalCardBase>;
    $[5] = className;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}